<template>
	<div>
		<div class="margin-top-15">
			<!-- <vButton theme="warning" class="margin-right-10">文件夹上传</vButton> -->
			<vButton v-if="alltype!='query'" theme="primary" class="margin-left-10" @click="uploadImage">{{$t('erp.product.image_upload',{defaultValue:'图片上传'})}}</vButton>
			<vButton class="margin-left-10" theme="warning" @click="downImage()">{{$t('global.common.batch_download',{defaultValue:'批量下载'})}}</vButton>
		</div>
		<Table
			class="margin-left-10 margin-right-10 margin-top-15"
			:columns="columns"
			:data="formList"
			size="small"
			@on-selection-change="handleChecked"
			ref="table"
			border
		></Table>
		<!-- 图片弹框 -->
		<vModal
			class="hidefooter customerupload"
			v-model="operate.show"
			:title="operate.title"
			v-bind="operate"
		>
			<compUpload v-bind="getFileProps" @on-close="cancelUpload" @on-success="successData"></compUpload>
			<footer slot="footer" v-show="false"></footer>
		</vModal>
	</div>
</template>
<script>
import compUpload from "@components/templates/upload"
export default {
	props: ['alltype', 'imageformdata'],
	data() {
		return {
			formList: [],
			operate: {
				id: null,
				title: "",
				show: false,
				component: null
			},
		}
	},
	components: {
		compUpload,
	},
	// created(){
	//     // console.log(this.imageformdata)
	//     this.handledata()
	// },
	computed: {
		columns() {
			let _this = this;
			return [
				{
					type: 'selection',
					width: 60,
				},
				{
					title: this.$t('erp.product.thumbnail',{defaultValue:'缩略图'}),
					render: (h, { row }) => {
						return <div><img style='max-width: 150px;max-height: 60px' src={row.pictureUrl} /></div>
					}
				},
				{
					title: this.$t('global.common.name',{defaultValue:'图片名称'}),
					render: (h, { row }) => {
						return <div>{row.pictureName}</div>
					}
				},
				{
					title: "URL",
					render: (h, { row }) => {
						return <div>{row.pictureUrl}</div>
					}
				},
				{
					title: this.$t('global.common.operation',{defaultValue:'操作'}),
					// width: this.alltype != 'query' ? 140 : 0,
					render(h, { row, index }) {
                        let buttoncancel = ''
                        if(_this.alltype!=='query'){
                            buttoncancel = h('Button', {
								props: {
									type: "error",
									size: 'small'
								},
								on: {
									click: () => {
										_this.comremove(index)
									}
								}
							}, _this.$t('global.common.delete',{defaultValue:'删除'}))
                        }
						return h('div', [
							h('Button', {
								props: {
									type: "primary",
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										_this.downImage(row)
									}
								}
                            }, _this.$t('global.common.download',{defaultValue:'下载'})),
							buttoncancel,
						])
					}
				},
			]
		},
		getFileProps() {
			return {
				action: process.env.VUE_APP_APIURL_BOSS + '/api/v1/Product/uploadPic',
				name: "uploadPic",
			}
		},
	},
	methods: {
		handledata() {
			this.formList = this.imageformdata.pictures || []
		},

		handleChecked(selection, row) {
			this.checkedId = selection.map(item => {
				return item.pictureUrl;
			});
			// console.log(this.checkedId)
		},

		downImage(rowData) {
			let urls = rowData ? [rowData.pictureUrl] : this.checkedId;
            console.log(urls)
            if(!urls){ this.$VMessage.error(this.$t('erp.product.choose_image', { defaultValue: '请选择图片' })); return}
			for (var i = 0; i < urls.length; i++) {
			    var name = 'picture_' + i;
			    var image = new Image();
			    // 解决跨域 Canvas 污染问题
			    image.setAttribute('crossOrigin', 'anonymous');

			    image.onload = function () {
			        var canvas = document.createElement('canvas');
			        canvas.width = image.width;
			        canvas.height = image.height;

			        var context = canvas.getContext('2d');
			        context.drawImage(image, 0, 0, image.width, image.height);

			        var url = canvas.toDataURL(); // 得到图片的base64编码数据
			        canvas.toDataURL('image/png');

			        var a = document.createElement("a"); // 生成一个a元素
			        var event = new MouseEvent("click"); // 创建一个单击事件
			        a.download = name || "photo"; // 设置图片名称
			        a.href = url; // 将生成的URL设置为a.href属性
			        a.dispatchEvent(event); // 触发a的单击事件
			    };
			    image.src = urls[i];
			}
		},

		comremove(index) {
			this.formList.splice(index, 1);
		},
		uploadImage() {
			this.operate = {
				show: true,
				title: this.$t('erp.product.image_upload',{defaultValue:'图片上传'}),
			};
		},
		successData(resData) {
			// console.log(resData)
			this.formList = this.formList.concat(resData.data);
			this.operate.show = false;
		},
		cancelUpload() {
			this.operate.show = false
		}

	},
	watch: {
		imageformdata() {
			// if(this.alltype != 'query'){
			this.handledata()
			// }
		}
	}
}
</script>
